import cashPng from '/img/icons/cash.png';
import cashWebp from '/img/icons/cash.webp';
import cashLargePng from '/img/icons/cash-large.png';
import cashLargeWebp from '/img/icons/cash-large.webp';

export const cashImages = {
  icon: {
    png: cashPng,
    webp: cashWebp,
  },
  iconLg: {
    png: cashLargePng,
    webp: cashLargeWebp,
  },
};
